import { useEffect, useState, useMemo } from 'react';
import React from 'react';
import { UserHandler, UserRole } from '../../../api/user-handler';
import cs from 'classnames';
import styles from './../styles.module.scss';
import { GroupInfo } from './../types';
import { errorHandlerFor400 } from '../../../api/services/errorhandler';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import CreateGroup from './modals/create-group';
import { successAlert } from '@components/toastify/notify-toast';
import { GroupsTable } from './GroupsTable';
import UserGroupSection from './GroupSelection';
import { Button } from 'antd';
import classNames from 'classnames';
import { GroupList } from './constants';
import { BsPlusLg } from 'react-icons/bs';
import DynamicLeftNav from '../left-nav';


const GroupManagement: React.FC = () => {
    const [selectedGroupInfo, setSelectedGroupInfo] = useState<GroupInfo | null>(
        null
    );
    const [searchText, setSearchText] = useState('');
    const [showGroupModal, setShowGroupModal] = useState(false);
    const [groupsList, setGroupsList] = useState<GroupList[]>([]);
    const [rolesList, setRolesList] = useState<UserRole[]>([]);
    const [showUserSectionLoader, toggleUserSectionLoader] = useState(false);
    const { envVariables: Env } = useSelector((store:RootState)=> store.AccountReducer);

    const onGroupInfoResponse = (res: any) => {
        const _selectedGroupInfo: NonNullable<any> = {
            ...res
        };
        setSelectedGroupInfo(_selectedGroupInfo);
        toggleUserSectionLoader(false);
    };

    const onGroupSelection = (user: any) => {
        toggleUserSectionLoader(true);
        setSelectedGroupInfo({
           ...user
        });
        UserHandler.GetUserInfo(`${Env?.REACT_APP_PLATFORM_URL}/usermanagement/api`, user.id, onGroupInfoResponse, res => {
            errorHandlerFor400(res);
            toggleUserSectionLoader(false);
        });
    };

    const getAllRoles = () => {
        UserHandler.GetAllRoles(`${Env?.REACT_APP_PLATFORM_URL}/usermanagement/api`, res => {
            setRolesList(res);
        });
    };

    const setAllGroups = () => {
        UserHandler.GetAllGroups(`${Env?.REACT_APP_PLATFORM_URL}/usermanagement/api`, (res :GroupList[]) => {
            setGroupsList(res);
        });
    };

    const getAllGroups = () => {
        UserHandler.GetAllGroups(`${Env?.REACT_APP_PLATFORM_URL}/usermanagement/api`, (res :GroupList[]) => {
            !!res.length && onGroupSelection(res[0]);
            setGroupsList(res);
        });
    };

    useEffect(() => {
        if(Env?.REACT_APP_PLATFORM_URL){
        getAllRoles();
        getAllGroups();
        }
    }, [Env?.REACT_APP_PLATFORM_URL]);

    const handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    const usersListToShow = useMemo(() => {
        const _searchText = searchText.toLowerCase();
        return groupsList.filter(
            group => group.name.toLowerCase().includes(_searchText)
        );
    }, [groupsList, searchText]);

    const HandleCloseGroupModal = () => {
        setShowGroupModal(false);
    };
    
    const handleCreateGroup = (payload: any) => {
         UserHandler.CreateGroup(
                `${Env?.REACT_APP_PLATFORM_URL}/usermanagement/api`,
                payload,
                (response: any) => {
                  if (response) {
                    successAlert(response);
                    setShowGroupModal(false);
                    setAllGroups();
                  } else {
                    console.error(response);
                  }
                },
                (error: any) => {
                  console.error(error);
                }
              );
    };

    const onDeleteGroup = (groupId: string) => {
        UserHandler.DeleteGroup(`${Env?.REACT_APP_PLATFORM_URL}/usermanagement/api`, groupId, (res:any) => {
            if (res) {
                successAlert(res);
                getAllGroups();
            }
          },
          (error: any) => {
            console.error(error);
          });
    };

    const handleEditGroup = (group: any) => {
        const { id, ...groupWithoutId } = group; 
        UserHandler.UpdateGroup(
            `${Env?.REACT_APP_PLATFORM_URL}/usermanagement/api`, id, groupWithoutId,
            (response: any) => {
              if (response) {
                successAlert(response);
                setAllGroups();
              }
            },
            (error: any) => {
              console.error(error);
            }
        );
    };

  
    return (
        <section className={cs(styles['admin__container'])}>
            <DynamicLeftNav selected_id='group' type="admin" />
            <div className={styles['content_holder']}>
                <header>
                    <h1>
                        <img src="/icons/user-manage.svg" alt="" />
                        Group Management
                    </h1>
                </header>
                <br/>
                <div className={styles['pageTableHeader']}>
                    <div
                        className={cs(
                            'search__input__container',
                            styles['search__input__container']
                        )}
                        style={{marginRight:20}}
                    >
                        <input
                            value={searchText}
                            onChange={handleSearchTextChange}
                            className="search_input"
                            placeholder="Search Group"
                        />

                        {!!searchText && (
                            <button
                                onClick={() => {
                                    setSearchText('');
                                }}
                            >
                                <img
                                    src="/icons/treeview/search-cross.svg"
                                    alt=""
                                    className="search_reset"
                                />
                            </button>
                        )}
                    </div>
                    <Button
            className={classNames("btn-lg btn-yellow-transparent", styles["center"], styles["btn-lg"])}
            onClick={()=>setShowGroupModal(true)}
          >
            <BsPlusLg />
            <span style={{ marginLeft: '4px' }}>Group</span>
          </Button>
                </div>
                
                        <div className={styles['mainContainer']}>
                            <GroupsTable
                                groupList={usersListToShow}
                                onGroupSelection={onGroupSelection}
                            />
                            <UserGroupSection
                                roleList={rolesList}
                                selectedGroupInfo={selectedGroupInfo}
                                onEdit={handleEditGroup}
                                onDelete={onDeleteGroup}
                                showLoader={showUserSectionLoader}
                            />
                        </div>
                <CreateGroup
                    visible={showGroupModal}
                    onCancel={HandleCloseGroupModal}
                    roles={rolesList}
                    onSubmit={handleCreateGroup}
                    submitButtons={
                        <div className={styles['addEditNifiModal__actionBtns']}>
                            <button
                                className="btn btn-lg btn-yellow"
                                type="submit"
                            >
                               Save 
                            </button>
                            <button
                                className="btn btn-lg btn-grey"
                                type="button"
                                onClick={HandleCloseGroupModal}
                            >
                                Cancel
                            </button>
                        </div>
                    }
                />
            </div>
        </section>
    );
};

export default GroupManagement;
